import Story from "./Components/Story/Story";

function App() {
  return (
    <div className="app">
      <Story />
    </div>
  );
}

export default App;
